import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Trans, useTranslation } from "react-i18next";
import { useForm, SubmitHandler } from "react-hook-form";
import SelectElement from "../components/event-selection/selectElement";
import TextArea from "../components/event-selection/textArea";
import Loaing from "../icons/loaing";
import ConfirmModal from "../components/ConfirmModal";
import postEvent from "../services/eventService";
import FormBorder from "../components/formBorder";
import { PDFDownloadLink } from "@react-pdf/renderer";
import postNothingToDeclare from "../services/nothingToDeclare.service";
import { NothingToDeclarePDF } from "../components/dashboard/nothing-to-declare-pdf";
export type NothingToDeclareTypes = {
  month: string;
  comment: string;
  printmonth?: boolean;
  printcomment?: boolean;
};

const schema = yup.object({
  month: yup.string().required(),
  comment: yup.string(),
});

const NothingToDeclare = () => {
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pdfData, setPdfData] = useState<any>(undefined);

  const { t } = useTranslation();

  const handleDownload: SubmitHandler<NothingToDeclareTypes> = async (data) => {
    setPdfData(data);
  };

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<NothingToDeclareTypes>({ resolver: yupResolver(schema) });

  const onSubmit: SubmitHandler<NothingToDeclareTypes> = async (data) => {
    setLoading(true);
    try {
      const { printmonth, printcomment, ...rest } = data;
      const response = await postNothingToDeclare({ ...rest });

      if (response.message === "created") {
        const eventpost = await postEvent({ eventId: response.data._id });
        if ((eventpost.message = "created")) {
          toast.success("nothing to declare event created successfully!");
          setLoading(false);
          navigate("/confirm");
        }
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };
  const resetForm = () => {
    setConfirmModalVisible(false);
    setPdfData(null);
    reset();
  };

  return (
    <section className="relative font-Poppins px-[20px] lg:px-0">
      <div>
        <div className="grid gap-3 lg:mx-10">
          <div className="w-16 h-16">
            <img
              src="/images/report.png"
              alt="!"
              className="max-w-full h-auto"
            />
          </div>
          <h1 className="text-4xl font-bold">
            <Trans i18nKey="Nothing to declare">Nothing to declare</Trans>
          </h1>
          <p className="text-xl text-[#6B6B6B]">
            <Trans i18nKey="nothing_to_declare_form_message">
              This form is to be completed at the end of the month, only if you
              have no other events to report for that same month.
            </Trans>
          </p>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-end gap-[15px] lg:px-[20px] my-5 lg:my-10">
          <button
            type="button"
            className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
            onClick={() => setConfirmModalVisible(true)}
          >
            <Trans t={t}>Reset</Trans>
          </button>
          {pdfData ? (
            <PDFDownloadLink
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              document={<NothingToDeclarePDF formData={pdfData} />}
              fileName={"nothing-to-declare.pdf"}
            >
              {({ blob, url, loading, error }) =>
                loading ? "Loading..." : "Download PDF"
              }
            </PDFDownloadLink>
          ) : (
            <button
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={handleSubmit(handleDownload)}
            >
              <Trans>Generate PDF</Trans>
            </button>
          )}
        </div>

        <FormBorder>
          <div className="grid gap-5">
            <SelectElement
              register={register}
              errors={errors}
              name="month"
              printEnabled
              label="I declare that I have no events to report for the month of:"
              options={[
                "january",
                "february",
                "march",
                "april",
                "may",
                "june",
                "july",
                "august",
                "september",
                "october",
                "november",
                "december",
              ]}
              translateId="I declare that I have no events to report for the month of:"
            />

            <TextArea
              register={register}
              errors={errors}
              name="comment"
              label="nothing_comment"
              printEnabled
            />
          </div>
        </FormBorder>
        <div className="flex justify-end lg:px-[20px] mt-10">
          <button
            type={"submit"}
            className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
          >
            <Trans i18nKey="Submit">Submit</Trans>
          </button>
          {loading && <Loaing />}
        </div>
      </form>
      <ConfirmModal
        isOpen={confirmModalVisible}
        setIsOpen={setConfirmModalVisible}
        onConfirm={resetForm}
      />
    </section>
  );
};

export default NothingToDeclare;
